import React from 'react'
import { Box, Typography, styled, IconButton, Tooltip } from '@material-ui/core'
import { Truck, User as UserIcon, Printer, FolderOpen } from 'phosphor-react'

import formatter from '@/services/formatter'

import { TableHeaderContainer } from './styles'
import { CollectQuickFormEdit } from '../QuickEdit'
import { CollectStatus } from './Status'
import { useResponsive } from '@/hooks/useResponsive'

export function IssuedCollectsTableHeader({ data: collect, onPrint }) {
  const current = collect.header

  const isMobile = useResponsive('down', 'sm')

  return (
    <TableHeaderContainer>
      <Box
        flex={1}
        display="flex"
        alignItems="flex-start"
        gridGap="1rem"
        flexDirection={isMobile ? 'column' : 'row'}
      >
        <Box display="flex" flex={1} flexDirection="column" gridGap="1rem">
          <Box display="flex" gridGap="1rem">
            <Box>
              <Typography variant="h3">
                N° {current.id_agendamento || '000000'}
              </Typography>

              <Typography variant="body2">{current.id_coleta}</Typography>
            </Box>

            <CollectStatus
              label={current.status.title}
              statusId={current.status.id}
            />
          </Box>

          <Box gridGap="1rem" display="flex">
            <Typography component="span" variant="body2">
              <label>EMISSÂO:</label>

              {formatter(current.vpt_data_emissao).toSimpleDate()}
            </Typography>

            <Typography component="span" variant="body2">
              <label>COLETA:</label>

              {formatter(current.vpt_dcoleta).toSimpleDate()}
            </Typography>
          </Box>
        </Box>

        <Box display="flex" gridGap="1rem">
          <Tooltip title="Reabrir coleta">
            <span>
              <IconButton
                size="medium"
                variant="contained"
                color="primary"
                // onClick={() => onPrint(current.id_coleta)}
                disabled={!current.can_reopen}
              >
                <FolderOpen weight="duotone" />
              </IconButton>
            </span>
          </Tooltip>

          <CollectQuickFormEdit
            disabled={!current.can_edit}
            initialData={{
              id_coleta: current?.id_coleta,
              vpt_placa: current?.vpt_placa,
              vpt_motorista: current?.vpt_motorista,
              vpt_cod_motorista: current?.vpt_cod_motorista,
            }}
          />

          <Tooltip title="Imprimir">
            <IconButton
              size="medium"
              variant="contained"
              color="primary"
              onClick={() => onPrint(current.id_coleta)}
              disabled={!current.can_print}
            >
              <Printer weight="duotone" />
            </IconButton>
          </Tooltip>
        </Box>
      </Box>

      <Box
        display="flex"
        gridGap="1rem"
        my="0.5rem"
        flexDirection={isMobile ? 'column' : 'row'}
      >
        <Block primary={current.vpt_placa} secondary="Placa" icon={Truck} />

        <Block
          minWidth={300}
          primary={
            <>
              {current.vpt_motorista}
              {', '}
              {formatter(current.vpt_cod_motorista).toCPF()}
            </>
          }
          secondary="Motorista"
          icon={UserIcon}
        />
      </Box>
    </TableHeaderContainer>
  )
}

// -----------------------------------------------------------------------

const BlockContainer = styled(Box)(({ theme }) => ({
  padding: '0.75rem 1rem',
  maxWidth: 'min(calc(100vw - 4rem), 500px)',
  borderRadius: 4,

  borderWidth: 1,
  borderStyle: 'solid',
  borderColor: theme.palette.divider,
  // background: lighten(theme.palette.info.main, 0.95),

  '& .MuiAvatar-root': {
    height: 30,
    width: 30,
    // background: theme.palette.info.dark,
  },
}))

function Block({ primary, secondary, icon: Icon, ...other }) {
  return (
    <BlockContainer
      display="flex"
      flexDirection="row"
      alignItems="center"
      gridGap="1rem"
      {...other}
    >
      <Box>
        <Icon weight="regular" size={20} />
      </Box>

      <Box>
        <Typography variant="body2" color="textSecondary">
          {secondary}
        </Typography>

        <Typography variant="body1">{primary}</Typography>
      </Box>
    </BlockContainer>
  )
}
